import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/Hero.css";

import img1 from "../schoolPhotos/CATSPreschool/img7.jpeg";
import img2 from "../schoolPhotos/CATSPreschool/img6.jpeg";
import img3 from "../schoolPhotos/CATSPreschool/img5.jpeg";
import img4 from "../HomePageSliderImages/slider-img1.jpeg";
import img5 from "../HomePageSliderImages/slider-img2.jpeg";

export default function Hero() {
  const slides = [
    {
      image: img1,
      tag: "Hands-on STEM",
      title: "Learn by building",
      accent: "yellow",
    },
    {
      image: img2,
      tag: "Robotics",
      title: "Ideas become creations",
      accent: "blue",
    },
    {
      image: img3,
      tag: "Innovation",
      title: "Curiosity in action",
      accent: "purple",
    },
    {
      image: img4,
      tag: "Coding",
      title: "Think. Create. Solve.",
      accent: "teal",
    },
    {
      image: img5,
      tag: "Future Skills",
      title: "Learning beyond textbooks",
      accent: "yellow",
    },
  ];

  const programs = [
    {
      number: "01",
      label: "BUILD",
      title: "Robotics",
      text: "Students explore technology through building, experimenting and solving practical challenges.",
      accent: "yellow",
      icon: (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <rect
            x="5"
            y="7"
            width="14"
            height="11"
            rx="3"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
          />

          <path
            d="M9 7V5.5M15 7V5.5M8.5 12h.01M15.5 12h.01M9 15h6"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </svg>
      ),
    },
    {
      number: "02",
      label: "EXPLORE",
      title: "Artificial Intelligence",
      text: "Introduce students to AI concepts, emerging technologies and logical problem-solving.",
      accent: "purple",
      icon: (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M9 4.5A3.5 3.5 0 0 0 5.5 8v1A3.5 3.5 0 0 0 4 15.16 3.5 3.5 0 0 0 9 18.33M15 4.5A3.5 3.5 0 0 1 18.5 8v1a3.5 3.5 0 0 1 1.5 6.16A3.5 3.5 0 0 1 15 18.33M9 4.5v15M15 4.5v15M9 9h2M13 15h2"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
          />
        </svg>
      ),
    },
    {
      number: "03",
      label: "CREATE",
      title: "Coding",
      text: "Build computational thinking and real-world problem-solving through engaging coding activities.",
      accent: "blue",
      icon: (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="m9 8-4 4 4 4M15 8l4 4-4 4M13 5l-2 14"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.9"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      number: "04",
      label: "DISCOVER",
      title: "Hands-on STEM",
      text: "Connect science, technology, engineering and mathematics through meaningful projects.",
      accent: "teal",
      icon: (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M9 3h6M10 3v5l-4.7 8.1A3.2 3.2 0 0 0 8.07 21h7.86a3.2 3.2 0 0 0 2.77-4.9L14 8V3"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />

          <path
            d="M7.4 15h9.2"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.7"
          />
        </svg>
      ),
    },
  ];

  const features = [
    {
      number: "01",
      label: "IMAGINE",
      title: "Innovative Approach",
      text: "Spark creativity through hands-on STEM learning and practical exploration.",
      imgSrc: "/images/innovative.png",
      accent: "yellow",
    },
    {
      number: "02",
      label: "LEARN",
      title: "Expert Curriculum",
      text: "Structured learning experiences designed to build useful real-world skills.",
      imgSrc: "/images/curriculum.png",
      accent: "blue",
    },
    {
      number: "03",
      label: "ENGAGE",
      title: "Gamified Learning",
      text: "Interactive methods make learning technology engaging and enjoyable.",
      imgSrc: "/images/gamification.png",
      accent: "purple",
    },
    {
      number: "04",
      label: "GROW",
      title: "Future Ready Skills",
      text: "Prepare students for tomorrow's technology-driven world.",
      imgSrc: "/images/future.png",
      accent: "teal",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  /* =========================================
     AUTOMATIC SLIDER
  ========================================= */

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(
        (prev) => (prev + 1) % slides.length
      );
    }, 3500);

    return () => clearInterval(interval);
  }, [slides.length]);

  const previousSlide = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? slides.length - 1 : prev - 1
    );
  };

  const nextSlide = () => {
    setCurrentIndex(
      (prev) => (prev + 1) % slides.length
    );
  };

  const scrollToSection = (event, sectionId) => {
    event.preventDefault();

    const section =
      document.getElementById(sectionId);

    if (!section) return;

    const headerOffset = 100;

    const position =
      section.getBoundingClientRect().top +
      window.scrollY -
      headerOffset;

    window.scrollTo({
      top: position,
      behavior: "smooth",
    });
  };

  return (
    <main className="ms-home">
      {/* =====================================================
          HERO
      ===================================================== */}

      <section className="ms-hero-stage">
        <div className="ms-hero-grid" />

        <div className="ms-hero-blue-glow" />
        <div className="ms-hero-yellow-glow" />

        <div className="container ms-main-container">
          <div className="row align-items-center g-5">
            {/* ================================
                LEFT
            ================================ */}

            <div className="col-lg-6">
              <div className="ms-hero-copy">
                <div className="ms-hero-eyebrow">
                  <span>✦</span>

                  LEARNING THROUGH TECHNOLOGY
                </div>

                <h1 className="ms-hero-title">
                  Empowering
                  <br />

                  young minds
                  <br />

                  to build{" "}
                  <span>
                    future.
                  </span>
                </h1>

                <p className="ms-hero-description">
                  MindSpark transforms the way students
                  experience technology through hands-on
                  Robotics, AI, Coding and STEM programs
                  that turn curiosity into creativity,
                  confidence and real-world skills.
                </p>

                <div className="ms-hero-actions">
                  <a
                    href="#mindspark-programs"
                    className="ms-primary-btn"
                    onClick={(event) =>
                      scrollToSection(
                        event,
                        "mindspark-programs"
                      )
                    }
                  >
                    Explore Our Programs

                    <span>→</span>
                  </a>

                  <a
                    href="#why-mindspark"
                    className="ms-secondary-btn"
                    onClick={(event) =>
                      scrollToSection(
                        event,
                        "why-mindspark"
                      )
                    }
                  >
                    Why MindSpark?
                  </a>
                </div>

                <div className="ms-value-row">
                  <div className="ms-value-item">
                    <span className="yellow">
                      ⚙
                    </span>

                    Hands-on learning
                  </div>

                  <div className="ms-value-item">
                    <span className="blue">
                      ✦
                    </span>

                    Real projects
                  </div>

                  <div className="ms-value-item">
                    <span className="teal">
                      ◇
                    </span>

                    Future-ready skills
                  </div>
                </div>
              </div>
            </div>

            {/* ================================
                RIGHT
            ================================ */}

            <div className="col-lg-6">
              <div className="ms-slider-area">
                <div className="ms-floating-label ms-floating-ai">
                  <span className="purple" />

                  AI & Innovation
                </div>

                <div className="ms-floating-label ms-floating-robotics">
                  <span className="yellow" />

                  Robotics
                </div>

                <div className="ms-image-slider">
                  {slides.map((slide, index) => (
                    <img
                      key={index}
                      src={slide.image}
                      alt={`MindSpark ${slide.tag} activity`}
                      className={`ms-slide-image ${
                        index === currentIndex
                          ? "active"
                          : ""
                      }`}
                    />
                  ))}

                  <div className="ms-image-overlay" />

                  <div className="ms-slide-content">
                    <span
                      className={`ms-slide-tag ${slides[currentIndex].accent}`}
                    >
                      {slides[currentIndex].tag}
                    </span>

                    <strong>
                      {slides[currentIndex].title}
                    </strong>
                  </div>

                  <div className="ms-image-counter">
                    <strong>
                      {String(
                        currentIndex + 1
                      ).padStart(2, "0")}
                    </strong>

                    <span />

                    {String(
                      slides.length
                    ).padStart(2, "0")}
                  </div>

                  <button
                    type="button"
                    className="ms-slide-arrow ms-slide-prev"
                    onClick={previousSlide}
                    aria-label="Previous image"
                  >
                    ‹
                  </button>

                  <button
                    type="button"
                    className="ms-slide-arrow ms-slide-next"
                    onClick={nextSlide}
                    aria-label="Next image"
                  >
                    ›
                  </button>
                </div>

                <div className="ms-slider-caption">
                  {slides[currentIndex].title}
                </div>

                <div className="ms-slider-footer">
                  <div className="ms-slider-dots">
                    {slides.map((_, index) => (
                      <button
                        type="button"
                        key={index}
                        aria-label={`Show slide ${
                          index + 1
                        }`}
                        className={`ms-slider-dot ${
                          index === currentIndex
                            ? "active"
                            : ""
                        }`}
                        onClick={() =>
                          setCurrentIndex(index)
                        }
                      />
                    ))}
                  </div>

                </div>

                <div
                  className="ms-auto-progress"
                  key={currentIndex}
                >
                  <span />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          WHAT WE DO
      ===================================================== */}

      <section
        id="mindspark-programs"
        className="ms-programs-section"
      >
        <div className="ms-program-bg-shape ms-program-shape-one" />
        <div className="ms-program-bg-shape ms-program-shape-two" />

        <div className="ms-section-grid" />

        <div className="container ms-main-container">
          <div className="ms-section-heading">
            <div className="ms-section-kicker">
              <span />

              WHAT WE DO
            </div>

           <h2>
  Learning science through
  <br />

  <span>
    technology.
  </span>
</h2>

            <p>
              Students don't just learn concepts at
              MindSpark. They experience them by
              building, exploring, experimenting and
              creating.
            </p>
          </div>

          <div className="ms-programs-wrapper">
            <div className="row g-4">
              {programs.map((program) => (
                <div
                  key={program.title}
                  className="col-12 col-sm-6 col-xl-3"
                >
                  <article
                    className={`ms-program-card ${program.accent}`}
                  >
                    <div className="ms-card-big-number">
                      {program.number}
                    </div>

                    <div className="ms-program-card-top">
                      <div className="ms-program-icon">
                        {program.icon}
                      </div>

                      <div className="ms-program-label">
                        {program.label}
                      </div>
                    </div>

                    <div className="ms-program-accent-line" />

                    <h3>{program.title}</h3>

                    <p>{program.text}</p>

                    <div className="ms-program-footer">
                      <span>
                        Explore
                      </span>

                      <span className="ms-card-arrow">
                        ↗
                      </span>
                    </div>

                    <div className="ms-card-circle" />
                  </article>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          WHY MINDSPARK
      ===================================================== */}

      <section
        id="why-mindspark"
        className="ms-why-section"
      >
        <div className="ms-why-grid" />

        <div className="ms-why-glow ms-why-glow-blue" />
        <div className="ms-why-glow ms-why-glow-yellow" />

        <div className="container ms-main-container">
          <div className="ms-why-heading-row">
            <div className="ms-why-heading">
              <div className="ms-section-kicker light">
                <span />

                WHY MINDSPARK
              </div>

              <h2>
                Designed to turn
                <br />

                curiosity{" "}
                <span>
                  into capability.
                </span>
              </h2>
            </div>

            <p className="ms-why-intro">
              Our learning approach helps students
              understand, create and solve with
              technology instead of simply consuming it.
            </p>
          </div>

          <div className="ms-learning-journey">
            <div className="ms-journey-line" />

            <div className="row g-4">
              {features.map((feature) => (
                <div
                  className="col-12 col-sm-6 col-lg-3"
                  key={feature.title}
                >
                  <article
                    className={`ms-feature-card ${feature.accent}`}
                  >
                    <span className="ms-feature-number">
                      {feature.number}
                    </span>

                    <div className="ms-feature-icon">
                      <img
                        src={feature.imgSrc}
                        alt=""
                        aria-hidden="true"
                      />
                    </div>

                    <span className="ms-feature-label">
                      {feature.label}
                    </span>

                    <h3>{feature.title}</h3>

                    <p>{feature.text}</p>

                    <div className="ms-feature-bottom">
                      <span className="ms-feature-dot" />

                      <span className="ms-feature-arrow">
                        →
                      </span>
                    </div>
                  </article>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
